import { render } from "./ChildInfoPage.vue?vue&type=template&id=6e32fa1e&ts=true"
import script from "./ChildInfoPage.vue?vue&type=script&lang=ts"
export * from "./ChildInfoPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__